<script>
import ModelIndex from "../models/index"
import JalaHarvestResourceName from "@/components/JalaHarvestResourceName.vue"

export default {
  extends: ModelIndex,
  page: {
    title: "Harvests",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('harvests.plural')) }},
    resourceRoute: {default: 'harvests'},
    modelVariable: {default: 'harvest'},
    denyExport: {default: false}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('harvests.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('harvests.plural')),
          href: "/harvests",
          active: true,
        },
      ],
      sortBy: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').shift()) || 'ordered_at',
      sortDesc: (this.$route.query.sort && this.$route.query.sort.split('|').shift().split(',').pop() === 'desc') || true,
      filterColumns: {
        order_id: { type: String, label: this.lodash.upperFirst(this.$t('harvests.order_id')) },
        'trip.driver': { type: String, label: this.lodash.upperFirst(this.$t('trips.driver')) },
        'customer.name': { type: String, label: this.lodash.upperFirst(this.$t('harvests.customer')) },
        ordered_at: { type: Date, label: this.lodash.upperFirst(this.$t('harvests.ordered_at')) },
        due_at: { type: Date, label: this.lodash.upperFirst(this.$t('harvests.due_at')) },
      }
    }
  },
  computed: {
    columns() {
      return {
        ['harvest']: [
          { key: 'index', label: '#', sortable: false, style: { width: '1%' } },
          {
            key: 'jala_harvest_id',
            label: this.lodash.upperFirst(this.$t('harvests.jala_harvest')),
            thStyle: { minWidth: '150px' },
            sortable: true,
            component: JalaHarvestResourceName
          },
          {
            key: 'harvested_at',
            label: this.lodash.upperFirst(this.$t('harvests.harvested_at')),
            thStyle: { minWidth: '200px' },
            class: 'text-center',
            sortable: true,
            formatter: (value) => {
              return this.$moment(value).format('DD MMMM YYYY');
            }
          },
          {
            key: 'weight',
            label: this.lodash.upperFirst(this.$t('harvests.weight')),
            thStyle: { minWidth: '130px' },
            class: 'text-end',
            sortable: true,
            formatter: (value) => {
              return this.$numeral(value).format('0,0.[00]');
            }
          },
          {
            key: 'size',
            label: this.lodash.upperFirst(this.$t('harvests.size')),
            thStyle: { minWidth: '130px' },
            class: 'text-end',
            sortable: true,
            formatter: (value) => {
              return this.$numeral(value).format('0,0.[00]');
            }
          },
          {
            key: 'label',
            label: this.lodash.upperFirst(this.$t('harvests.label')),
            thStyle: { minWidth: '130px' },
            sortable: true
          },
          { key: 'action', class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    getModelName(value) {
      return this.$moment(value['harvested_at']).format('DD MMMM YYYY');
    },
    delete(value) {
      return this.$axios.delete(`/harvests/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/harvests', {
        params: {
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy},${this.sortDesc ? 'desc' : 'asc'}`,
          with:'cycle.pond.farm',
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          _denyShow: false,
          _denyEdit: false,
          _denyDelete: false
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
